import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from '../app/services/admin/AdminService';
import { Globals } from '../app/globals';
import { Idle } from '@ng-idle/core';
import { ToastrService } from 'ngx-toastr';
import { UserLoggedInService } from '../app/services/angular/UserLoggedIn';
import { isNull } from 'util';
import { CryptoJs } from 'app/shared/crypto-js/crypto-js.component';

@Component({
  selector: 'app-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.scss']
})
export class SsoComponent implements OnInit {

    token: string;
    authenticateUserData: any;
    user = {
        email: null,
        pass: null
    }

    constructor(
        private _activatedRoute: ActivatedRoute,
        private _AdminService: AdminService,
        private router: Router,
        public _Globals: Globals,
        private toastr: ToastrService,
        private _CryptoJs: CryptoJs,
        private _UserLoggedInService: UserLoggedInService,
        private idle: Idle
    ) {
        this._activatedRoute.params.subscribe(params => {
            this.token = params['token'];
            console.log('hex', this.token);
            console.log('binary', this.hex2bin(this.token));

            this.postTokenSSO(this.hex2bin(this.token));
        });
    }

    ngOnInit() {
    }

    postTokenSSO(token:string) {
        this._AdminService.postTokenSSO(token).subscribe((data:any) => {
            console.log('data', data);

            if (data.result.Result <= 0) {
                //-1 invalid user
                //0 invalid password
                this.toastr.error('Invalid login credentials', 'ELI');
                this.router.navigate(['/login']);
                return;
            }

            if (data.result.Result == 1) {

                this._Globals.deleteAllStorage();

                this._UserLoggedInService.setUserLoggedIn(true);
                this.idle.watch();
                this._Globals.setAnnouncementsStatus(true);

                this._Globals.setToken(data.result.AccessToken);
                this._Globals.setFullName(data.result.DskjoXCn0f, data.result.QyKZJFsEvu);
                this._Globals.setUserId(data.result.OepbCPnScZ);
                let mode: string;
                if (String(this._CryptoJs.decrypt(data.result.kUvPfGbd6J, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*')) === 'Manager') {
                    mode = this._CryptoJs.encrypt('Administrator', '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*');
                    this._Globals.setUserType('manager');
                } else {
                    mode = data.result.kUvPfGbd6J;
                    this._Globals.setUserType('Administrator');
                }
                this._Globals.setMode(mode);
                this._Globals.setAvailableModes(data.result.v31Ng7c6zu);

                this._Globals.setUserEmail(data.result.L8xxJlbW63);
                this._Globals.setCanUserEditEmail(data.result.YE3 == 1 ? true : false);
                this._Globals.setIsUserStudent(data.result.NR9);
                this._Globals.setEnvironment(data.result.fDISWvalw6);
                this._Globals.setIsEntraUser(data.result.i908dOBEVP);
                this._Globals.setBetaAccess(data.result.z6NjHUJe4f);

                this.authenticateUserData = data.result;

                if (this._Globals.invitationLinkFrom === "") {
                    if (data.result.Status == 1 && (this._CryptoJs.decrypt(data.result.kUvPfGbd6J, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*') == "Client" || this._CryptoJs.decrypt(data.result.kUvPfGbd6J, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*') == "Rater")) {
                        let lastAssignment = data.result.LastAssignment;
                        let last360Assignment = data.result.Last360Assignment;

                        if (!isNull(lastAssignment)) {
                            if (lastAssignment.AssignmentId != 0) {
                                //redirect to the assessment
                                //assigned_assessment/pending/1/558/ELI%20-%20Self%20Assessment/en
                                this.router.navigate(['/app/assigned_assessment', 'pending',
                                    lastAssignment.AssessmentId,
                                    lastAssignment.AssignmentId,
                                    lastAssignment.AssessmentName,
                                    lastAssignment.Language],
                                    {state: {showBanner: false}});
                                $('body').css('cursor', 'default');
                                return;

                            }
                        } else if (!isNull(last360Assignment)) {
                            if (last360Assignment.AssignmentId != 0) {
                                //redirect to the 360 assessment
                                //assigned_assessment/rater/34/312/ELI%20360/en/Testicular%20Testasaurus
                                this.router.navigate(['/app/assigned_assessment', 'rater',
                                    last360Assignment.AssessmentId,
                                    last360Assignment.AssignmentId,
                                    last360Assignment.AssessmentName,
                                    last360Assignment.Language,
                                    last360Assignment.ClientFirstName + ' ' + last360Assignment.ClientLastName],
                                    {state: { showBanner: false }});
                                $('body').css('cursor', 'default');
                                return;

                            }
                        } else {
                            //redirecto to assessments page
                            console.log('NO ASSESSMENTS PEDINGS - NORMAL REDIRECT');
                        }
                    }
                }

                //Redirect user to the activate account screen when Status equals to 2 and user_type is 3 or 4
                let _data = Number(this._CryptoJs.decrypt(data.result.Ku1TT0DbLn, this._Globals.passString));
                if (data.result.Status == 2 && (_data == 3 || _data == 4)) {
                    this._Globals.clientOrRaterEmailFromLogin = data.result.Email;
                    this.redirectToActivateAccount();
                    return;
                }

                if (this._Globals.raterAssessmentId != undefined) {
                    if (data.result.Status == 1) {
                        //take assessment
                        this.router.navigate(['/app/assigned_assessment', "rater", this._Globals.raterAssignedAssessment, this._Globals.raterAssessmentName]);
                        $('body').css('cursor', 'default');
                        return;
                    }

                    if (data.result.Status == 2) {
                        this.redirectToActivateAccount();
                        return;
                    }

                    return;
                }

                if (this._Globals.isClientTakeAssessment) {
                    this.getAssignmentDetails(data.result.Status);
                    return;
                }

                if (this._Globals.isCoachSeeingResults) {
                    this.logginToAssessmentResults();
                    return;
                }

                if (!this._Globals.isCoachSeeingResults || !this._Globals.isClientTakeAssessment) {
                    this._Globals.loginModeredirection(this._CryptoJs.decrypt(data.result.kUvPfGbd6J, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                }
            }
        
        });
    }

    redirectToActivateAccount(): void {

        let lastAssignment = this.authenticateUserData.LastAssignment;
        let last360Assignment = this.authenticateUserData.Last360Assignment;

        if (!isNull(lastAssignment)) {
            if (lastAssignment.AssignmentId != 0) {
                //redirect to the assessment
                //assigned_assessment/pending/1/558/ELI%20-%20Self%20Assessment/en
                this._Globals.activateAccountAssessmentData = "/app/assigned_assessment/pending/" +
                    lastAssignment.AssessmentId + "/" +
                    lastAssignment.AssignmentId + "/" +
                    lastAssignment.AssessmentName + "/" +
                    lastAssignment.Language;
            }
        } else if (!isNull(last360Assignment)) {
            if (last360Assignment.AssignmentId != 0) {
                //redirect to the 360 assessment
                //assigned_assessment/rater/34/312/ELI%20360/en/Testicular%20Testasaurus
                this._Globals.activateAccountAssessmentData = "/app/assigned_assessment/rater/" +
                    last360Assignment.AssessmentId + "/" +
                    last360Assignment.AssignmentId + "/" +
                    last360Assignment.AssessmentName + "/" +
                    last360Assignment.Language + "/" +
                    last360Assignment.ClientFirstName + " " + last360Assignment.ClientLastName;
            }
        }

        console.log('Redirecting user to the activate account...');
        this.router.navigate(['/app/account_activation']); //, this.myGlobals.raterEmail]); 
        $('body').css('cursor', 'default');
        return;
    }

    getAssignmentDetails(status) {


        //validate the field status
        if (status == 1) {
            if (this._Globals.getUserId() == this._Globals.invitationLinkUserId) {
                if (this._Globals.invitationLinkFrom == "rater") {
                    this.router.navigate(['/app/assigned_assessment', this._Globals.invitationLinkFrom, this._Globals.invitationLinkAssessmentId, this._Globals.invitationLinkAssignmentId, this._Globals.invitationLinkAssessmentName, this._Globals.invitationLinkLanguage, this._Globals.invitationLinkFullName]);
                } else {
                    this.router.navigate(['/app/assigned_assessment', this._Globals.invitationLinkFrom, this._Globals.invitationLinkAssessmentId, this._Globals.invitationLinkAssignmentId, this._Globals.invitationLinkAssessmentName, this._Globals.invitationLinkLanguage]);
                }
                this._Globals.setMode(this._CryptoJs.encrypt('Client', '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                this._Globals.deactivateAllModes();
                this._Globals.client = true;
                this._Globals.selectedMode = "client";
                this._Globals.userLoggedIn();
            } else {
                //user login valit but not mach with client id with try to take
                this.toastr.warning('Invalid user credentials for this assessment', 'ELI');
            }
            $(".btn").prop("disabled", false);
            $('body').css('cursor', 'default');
        } else {
            this.router.navigate(['/app/account_activation']);
            return;
        }

    }

    logginToAssessmentResults() {
        if (this._Globals.getUserId() == this._Globals.aResultCoachId) {
            if (this._Globals.aResultUserType === "2") {
                this.router.navigate(['/app/co_a_report', this._Globals.invitationLinkAssignmentId]);
                this._Globals.setMode(this._CryptoJs.encrypt('Coach', '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                this._Globals.deactivateAllModes();
                this._Globals.coach = true;
                this._Globals.selectedMode = "coach";
            } else {
                this.router.navigate(['/app/c_a_report', this._Globals.invitationLinkAssignmentId]);
                this._Globals.setMode(this._CryptoJs.encrypt('Client', '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                this._Globals.deactivateAllModes();
                this._Globals.client = true;
                this._Globals.selectedMode = "client";
            }
            this._Globals.userLoggedIn();

        } else {
            //user login valit but not mach with client id with try to take
            this.toastr.warning('Invalid user credentials for this assessment', 'ELI');
        }
        $(".btn").prop("disabled", false);
        $('body').css('cursor', 'default');

    }

    hex2bin(hex) {
        var bytes = [], str;

        for (var i = 0; i < hex.length - 1; i += 2)
            bytes.push(parseInt(hex.substr(i, 2), 16));

        return String.fromCharCode.apply(String, bytes);
    }
}
